/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgSpecAdminCreate
 */
export interface OrgSpecAdminCreate {
    /**
     * 
     * @type {string}
     * @memberof OrgSpecAdminCreate
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgSpecAdminCreate
     */
    spec_name: string;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecAdminCreate
     */
    arc_flash_alerts: number;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecAdminCreate
     */
    fall_alerts: number;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecAdminCreate
     */
    impact_alerts: number;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecAdminCreate
     */
    current_sensitivity: number;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecAdminCreate
     */
    voltage_range: number;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecAdminCreate
     */
    voltage_sensitivity: number;
}

/**
 * Check if a given object implements the OrgSpecAdminCreate interface.
 */
export function instanceOfOrgSpecAdminCreate(value: object): value is OrgSpecAdminCreate {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('spec_name' in value) || value['spec_name'] === undefined) return false;
    if (!('arc_flash_alerts' in value) || value['arc_flash_alerts'] === undefined) return false;
    if (!('fall_alerts' in value) || value['fall_alerts'] === undefined) return false;
    if (!('impact_alerts' in value) || value['impact_alerts'] === undefined) return false;
    if (!('current_sensitivity' in value) || value['current_sensitivity'] === undefined) return false;
    if (!('voltage_range' in value) || value['voltage_range'] === undefined) return false;
    if (!('voltage_sensitivity' in value) || value['voltage_sensitivity'] === undefined) return false;
    return true;
}

export function OrgSpecAdminCreateFromJSON(json: any): OrgSpecAdminCreate {
    return OrgSpecAdminCreateFromJSONTyped(json, false);
}

export function OrgSpecAdminCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgSpecAdminCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'spec_name': json['spec_name'],
        'arc_flash_alerts': json['arc_flash_alerts'],
        'fall_alerts': json['fall_alerts'],
        'impact_alerts': json['impact_alerts'],
        'current_sensitivity': json['current_sensitivity'],
        'voltage_range': json['voltage_range'],
        'voltage_sensitivity': json['voltage_sensitivity'],
    };
}

export function OrgSpecAdminCreateToJSON(json: any): OrgSpecAdminCreate {
    return OrgSpecAdminCreateToJSONTyped(json, false);
}

export function OrgSpecAdminCreateToJSONTyped(value?: OrgSpecAdminCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'spec_name': value['spec_name'],
        'arc_flash_alerts': value['arc_flash_alerts'],
        'fall_alerts': value['fall_alerts'],
        'impact_alerts': value['impact_alerts'],
        'current_sensitivity': value['current_sensitivity'],
        'voltage_range': value['voltage_range'],
        'voltage_sensitivity': value['voltage_sensitivity'],
    };
}

